module.exports = __webpack_public_path__ + "static/media/ideaIcon.1d65accc.svg";